//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/reports';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            items: [],
            loading: true,
            filterKey: '',
            residents: [{ value: 0, label: 'All Residents' }],
            selectedResident: { value: 0, label: 'All Residents' }
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('ar-resident-ledger-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportArLedgerToExcel', function () {
            return _this.exportToExcel();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ar-resident-ledger-report');
        Event.$off('exportArLedgerToExcel');
    },

    methods: {
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                resident_id: this.selectedResident.value,
                exportExcel: true
            };

            this.createExport(data, BASE_URL + '/ledgers', 'ar-resident-ledger', '.xlsx');

            this.loading = false;
        },
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;
            axios.post(BASE_URL + '/ledgers').then(function (response) {
                _this2.items = response.data;
                _this2.items = _this2.items.filter(function (el) {
                    return !!el;
                });
                _this2.items.map(function (item) {
                    return _this2.residents.push({ value: item.resident_id, label: item.unit + ' | ' + item.resident });
                });
                _this2.loading = false;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/ArResidentLedgerReport.vue
// module id = 2rZZ
// module chunks = 0 1